<template>
  <div class="fixed-top navbar-elevation-all">
    <nav
      class="navbar navbar-expand-lg navbar-expand-md navbar-expand-sm navbar-dark navbar-elevation top-nav-container"
    >
      <div class="mobile-navbar-logo">
        <router-link class="navbar-brand" :to="{ path: '/' }"
          ><img
            class="navbar-logo"
            src="../../assets/topNav/lonxun-logo-01.png"
        /></router-link>
      </div>

      <button
        class="navbar-toggler topnav-toggler-icon"
        type="button"
        data-toggle="collapse"
        data-target="#top-nav-collapse"
      >
        <!--     <button class="navbar-toggler topnav-toggler-icon" type="button" data-toggle="collapse" data-target="#mobile-top-nav-collapse" >-->
        <div class="navbar-toggler-icon-1"></div>
        <div class="navbar-toggler-icon-2"></div>
        <div class="navbar-toggler-icon-2"></div>
      </button>

      <div
        class="collapse navbar-collapse top-navbar-collapse mobile-nav-collapse"
        id="top-nav-collapse"
      >
        <ul
          class="nav navbar-nav pop-menu t2-head head-font nav-stacked nav-ul mobile-nav-ul"
        >
          <li class="nav-item navbar-collapse dropdown mobile-dropdown-item">
            <label class="nav-link nav-text" @click="toHome">首页&nbsp;</label>
          </li>
          <div class="mobile-navbar-dropdown-line"></div>

          <li class="nav-item navbar-collapse dropdown mobile-dropdown-item">
            <label
              class="nav-link nav-text dropdown-toggle dropdown-toggle-split"
              id="nav-menu-about"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
              >{{ $t("navbar.About") }}&nbsp;</label
            >
            <div
              class="dropdown-menu navbar-dropdown-menu mobile-navbar-dropdown-menu"
              aria-labelledby="nav-menu-about"
            >
              <a
                class="dropdown-item navbar-dropdown-item"
                @click="toCompanyIntroduce"
                >{{ $t("navbar.CompanyProfile") }}</a
              >
              <div class="navbar-dropdown-line"></div>
              <a
                class="dropdown-item navbar-dropdown-item"
                @click="toCompanyNews"
                >{{ $t("navbar.CompanyNews") }}</a
              >
              <div class="navbar-dropdown-line"></div>
              <a class="dropdown-item navbar-dropdown-item" @click="toCooperate"
                >合作客户</a
              >
              <div class="navbar-dropdown-line"></div>
              <a
                class="dropdown-item navbar-dropdown-item"
                @click="toContactUs"
                >{{ $t("navbar.ContactUs") }}</a
              >
              <div class="navbar-dropdown-line"></div>
              <a class="dropdown-item navbar-dropdown-item" @click="toJoinUs">{{
                $t("navbar.JoinUs")
              }}</a>
            </div>
          </li>
          <div class="mobile-navbar-dropdown-line"></div>

          <li class="nav-item navbar-collapse dropdown mobile-dropdown-item">
            <label
              class="nav-link nav-text dropdown-toggle dropdown-toggle-split"
              id="nav-menu-produce"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
              >{{ $t("navbar.product") }}&nbsp;</label
            >
            <div
              class="dropdown-menu navbar-dropdown-menu mobile-navbar-dropdown-menu dropright"
              aria-labelledby="nav-menu-produce"
            >
              <!--  <a class="dropdown-item navbar-dropdown-item dropdown-toggle dropdown-toggle-split" id="nav-menu-pwmat" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">PWmat&nbsp;</a>
              <div class="dropdown-menu navbar-dropdown-menu mobile-navbar-dropdown-menu " aria-labelledby="nav-menu-pwmat">
                 <a class="dropdown-item navbar-dropdown-item" @click="toPWmatIntroduce">{{ $t('navbar.FunctionIntroduce') }}</a>
                 <div class="navbar-dropdown-line"></div>
                 <a class="dropdown-item navbar-dropdown-item" :href='PWMAT_RESOURCE+"pwmatTest.pdf"'>{{ $t('navbar.ProformanceTest') }}</a>
               </div>-->
              <a
                class="dropdown-item navbar-dropdown-item"
                @click="toPWmatIntroduce"
                >PWmat&nbsp;</a
              >
              <div class="navbar-dropdown-line"></div>
              <a
                class="dropdown-item navbar-dropdown-item"
                @click="toMLFFIntroduce"
                >PWMLFF</a
              >
              <div class="navbar-dropdown-line"></div>
              <a
                class="dropdown-item navbar-dropdown-item"
                @click="toLS3DFIntroduce"
                >LS3DF</a
              >
              <!-- <div class="navbar-dropdown-line"></div> -->
              <!-- <a class="dropdown-item navbar-dropdown-item" @click="toPWmatFreeDownload">试用版</a> -->
              <div class="navbar-dropdown-line"></div>
              <!--    <a class="dropdown-item navbar-dropdown-item" @click="toPWmatTrialDownload">试用版(docker镜像)</a> -->
              <!-- <div class="navbar-dropdown-line"></div> -->
              <!-- <a class="dropdown-item navbar-dropdown-item" @click="toMSTATIONIntroduce">单机版MSTATION</a> -->
              <!-- <div class="navbar-dropdown-line"></div> -->
              <!-- <a class="dropdown-item navbar-dropdown-item" @click="toDMSTATIONIntroduce">双机互联版MSTATION</a> -->
              <!-- <div class="navbar-dropdown-line"></div> -->
              <!-- <a class="dropdown-item navbar-dropdown-item" @click="toMCLUSTERIntroduce">集群版MCLUSTER</a> -->
              <!-- <div class="navbar-dropdown-line"></div> -->
              <!-- <a class="dropdown-item navbar-dropdown-item" @click="toMcloudIntroduce">机时租赁MCLOUD</a> -->
              <div class="navbar-dropdown-line"></div>
              <!-- <a class="dropdown-item navbar-dropdown-item" href="//www.pwmat.com/company-news-content/44">大体系计算模块CPM</a> -->
              <div class="navbar-dropdown-line"></div>
              <a
                class="dropdown-item navbar-dropdown-item"
                @click="toModuleDownload"
                >Module</a
              >
              <a
                class="dropdown-item navbar-dropdown-item"
                @click="topwkitDownload"
                >PWkit</a
              >
              <!-- <div class="navbar-dropdown-line"></div> -->
              <a
                class="dropdown-item navbar-dropdown-item"
                @click="toPWMGUIIntroduce"
                >Q-Flow</a
              >
              <a
                class="dropdown-item navbar-dropdown-item"
                @click="toQStudioIntroduce"
                >Q-Studio</a
              >
              <a
                class="dropdown-item navbar-dropdown-item"
                @click="toIntegration"
                >软硬一体化</a
              >
              <!-- <div class="navbar-dropdown-line"></div> -->
              <!-- <a class="dropdown-item navbar-dropdown-item" :href="XXXXX">Database</a> -->
            </div>
          </li>
          <!--         <div class="mobile-navbar-dropdown-line"></div>

           <li class="nav-item navbar-collapse dropdown mobile-dropdown-item">
            <label class="nav-link nav-text dropdown-toggle dropdown-toggle-split" id="nav-menu-test" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">性能测试&nbsp;</label>
            <div class="dropdown-menu navbar-dropdown-menu mobile-navbar-dropdown-menu" aria-labelledby="nav-menu-test">
              <div v-for="testDocument in testDocuments"
               :key="testDocument.id"
              >
                <a v-if="testDocument.title=='速度测试'" class="dropdown-item navbar-dropdown-item" href="/pwmat-resource/pwmatSpeedTest.pdf">{{testDocument.title}}</a>

                <a v-if="testDocument.title!=='速度测试'" class="dropdown-item navbar-dropdown-item" @click="toTestDocument(testDocument.id)">{{testDocument.title}}</a>
                <div class="navbar-dropdown-line"></div>
              </div>

            </div>
          </li> -->

          <div class="mobile-navbar-dropdown-line"></div>

          <li class="nav-item navbar-collapse dropdown mobile-dropdown-item">
            <label
              class="nav-link nav-text dropdown-toggle dropdown-toggle-split"
              id="nav-menu-course"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
              >{{ $t("navbar.Solution") }}&nbsp;</label
            >
            <div
              class="dropdown-menu navbar-dropdown-menu mobile-navbar-dropdown-menu dropright"
              aria-labelledby="nav-menu-course"
            >
              <a class="dropdown-item navbar-dropdown-item" @click="toAcademic"
                >学术教育方案</a
              >
              <div class="navbar-dropdown-line"></div>
              <a
                class="dropdown-item navbar-dropdown-item"
                @click="toIndustrial"
                >工业行业方案</a
              >
            </div>
          </li>
          <div class="mobile-navbar-dropdown-line"></div>

          <li class="nav-item navbar-collapse dropdown mobile-dropdown-item">
            <!--    <div class="nav-link nav-text dropdown-toggle dropdown-toggle-split" id="nav-menu-test"></div>-->
            <a
              class="nav-link nav-text dropdown-toggle-split"
              href="https://mcloud.lonxun.com"
              target="_blank"
              >Mcloud</a
            >

            <div class="mobile-navbar-dropdown-line"></div>
          </li>

          <li class="nav-item navbar-collapse dropdown mobile-dropdown-item">
            <label
              class="nav-link nav-text dropdown-toggle dropdown-toggle-split"
              id="nav-menu-download"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
              >{{ $t("navbar.Download") }}&nbsp;</label
            >
            <div
              class="dropdown-menu navbar-dropdown-menu mobile-navbar-dropdown-menu dropright"
              aria-labelledby="nav-menu-download"
            >
              <div class="dropdown-submenu">
                <a
                  class="dropdown-item navbar-dropdown-item dropdown-toggle dropdown-toggle-split"
                  id="nav-menu-software-download"
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                  >{{ $t("navbar.SoftWareDownload") }}&nbsp;</a
                >
                <div
                  class="dropdown-menu navbar-dropdown-menu mobile-navbar-dropdown-menu"
                  aria-labelledby="nav-menu-software-download"
                >
                  <!--        <a class="dropdown-item navbar-dropdown-item" @click="toPWmatFreeDownload">PWmat试用License</a>-->
                  <div class="navbar-dropdown-line"></div>
                  <!--        <a class="dropdown-item navbar-dropdown-item" @click="toPWmatTrialDownload">PWmat试用版(docker镜像)</a>-->
                  <div class="navbar-dropdown-line"></div>
                  <a
                    class="dropdown-item navbar-dropdown-item"
                    @click="toGPUDownload"
                    >GPU版本</a
                  >
                  <div class="navbar-dropdown-line"></div>
                  <!--        <a class="dropdown-item navbar-dropdown-item" @click="toHighThroughputDownload">高通量平台</a>-->
                  <div class="navbar-dropdown-line"></div>
                  <a
                    class="dropdown-item navbar-dropdown-item"
                    @click="toDCUDownload"
                    >DCU版本</a
                  >
                  <a
                    class="dropdown-item navbar-dropdown-item"
                    @click="toCPUDownload"
                    >CPU版本</a
                  >
                  <a
                    class="dropdown-item navbar-dropdown-item"
                    @click="toWindowsDownload"
                    >Windows版本</a
                  >
                  <a
                    class="dropdown-item navbar-dropdown-item"
                    target="_blank"
                    href="http://longxun2015.mikecrm.com/y72WBOU"
                    >申请试用</a
                  >
                </div>
              </div>
              <div class="navbar-dropdown-line"></div>
              <a
                class="dropdown-item navbar-dropdown-item"
                @click="toLS3DFDownload"
                >LS3DF</a
              >
              <div class="navbar-dropdown-line"></div>
              <a
                class="dropdown-item navbar-dropdown-item"
                @click="toPWMLFFDownload"
                >PWMLFF</a
              >
              <div class="navbar-dropdown-line"></div>
              <a
                class="dropdown-item navbar-dropdown-item"
                @click="toPotentialDownload"
                >{{ $t("navbar.PotentialDownload") }}</a
              >
              <div class="navbar-dropdown-line"></div>
              <!--      <a class="dropdown-item navbar-dropdown-item" @click="toTutorials">Tutorials</a> -->
              <div class="navbar-dropdown-line"></div>
              <a
                class="dropdown-item navbar-dropdown-item"
                @click="toUtilityDownload"
                >Utility</a
              >
              <div class="navbar-dropdown-line"></div>
              <a
                class="dropdown-item navbar-dropdown-item"
                @click="toModuleDownload"
                >Module</a
              >
              <div class="navbar-dropdown-line"></div>
              <!-- <a class="dropdown-item navbar-dropdown-item" :href="PWMAT_RESOURCE+'Manual.pdf'" target="_blank">Manual</a> -->
              <div class="dropdown-submenu">
                <a
                  class="dropdown-item navbar-dropdown-item dropdown-toggle dropdown-toggle-split"
                  id="nav-menu-manual"
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                  >PWmat手册&nbsp;</a
                >
                <div
                  class="dropdown-menu dropdown-"
                  aria-labelledby="nav-menu-manual"
                >
                  <a
                    class="dropdown-item navbar-dropdown-item"
                    :href="PWMAT_RESOURCE + 'Manual_cn.pdf'"
                    target="_blank"
                    >中文版</a
                  >
                  <div class="navbar-dropdown-line"></div>
                  <a
                    class="dropdown-item navbar-dropdown-item"
                    :href="PWMAT_RESOURCE + 'Manual.pdf'"
                    target="_blank"
                    >英文版</a
                  >
                </div>
              </div>

              <div class="navbar-dropdown-line"></div>
              <a
                class="dropdown-item navbar-dropdown-item"
                :href="PWMAT_RESOURCE + 'Q-Flow_Manual.pdf'"
                target="_blank"
                >Q-Flow手册</a
              >
              <div class="navbar-dropdown-line"></div>
              <a
                class="dropdown-item navbar-dropdown-item"
                @click="topwkitDownload"
                >PWkit</a
              >
            </div>
          </li>
          <div class="mobile-navbar-dropdown-line"></div>

          <li class="nav-item navbar-collapse dropdown mobile-dropdown-item">
            <!--      <label class="nav-link nav-text " id="nav-menu-course" @click="toCourse">{{ $t('navbar.Course') }}&nbsp;</label> -->
            <label
              class="nav-link nav-text dropdown-toggle dropdown-toggle-split"
              id="nav-menu-course"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
              >{{ $t("navbar.Course") }}&nbsp;</label
            >
            <div
              class="dropdown-menu navbar-dropdown-menu mobile-navbar-dropdown-menu dropright"
              aria-labelledby="nav-menu-course"
            >
              <!--        <a class="dropdown-item navbar-dropdown-item" @click="toQuickStartTutorial">快速上手教程</a> -->
              <div class="navbar-dropdown-line"></div>
              <a class="dropdown-item navbar-dropdown-item" @click="toTutorials"
                >Tutorials教程</a
              >
              <a class="dropdown-item navbar-dropdown-item" @click="toCourse"
                >常用参数详解</a
              >
              <div class="navbar-dropdown-line"></div>
              <a class="dropdown-item navbar-dropdown-item" @click="toCase"
                >典型文献复现</a
              >
              <a class="dropdown-item navbar-dropdown-item" @click="toReadPaper"
                >发表论文解读</a
              >
              <a
                class="dropdown-item navbar-dropdown-item"
                @click="toModuleClass"
                >module小课堂</a
              >
              <div class="navbar-dropdown-line"></div>
              <!--     <a class="dropdown-item navbar-dropdown-item" target="_blank" href="https://space.bilibili.com/1965576887?spm_id_from=333.337.0.0">视频教程</a>  -->
              <div class="navbar-dropdown-line"></div>
              <a class="dropdown-item navbar-dropdown-item" @click="toTrain"
                >入门教程视频</a
              >
              <div class="navbar-dropdown-line"></div>
              <a class="dropdown-item navbar-dropdown-item" @click="toCamp"
                >专题课程视频</a
              >
              <div class="navbar-dropdown-line"></div>
              <a class="dropdown-item navbar-dropdown-item" @click="toSeminar"
                >大咖讲坛视频</a
              >
              <div class="navbar-dropdown-line"></div>
              <!--        <a class="dropdown-item navbar-dropdown-item" @click="toLongxunRoom">龙讯讲坛</a> -->
              <!--        <a class="dropdown-item navbar-dropdown-item" target="_blank" href="https://www.bilibili.com/video/BV1dU4y1y73k/?spm_id_from=333.999.0.0">龙讯讲坛</a> -->
            </div>
          </li>
          <!--   <div class="mobile-navbar-dropdown-line"></div> -->
          <!--    <li class="nav-item navbar-collapse dropdown mobile-dropdown-item"> -->
          <!--    <div class="nav-link nav-text dropdown-toggle dropdown-toggle-split" id="nav-menu-test"></div>-->
          <!--       <a class="nav-link nav-text  dropdown-toggle-split" href='http://login.lonxun.com/login' target="_blank">资源中心</a> -->

          <!--   <div class="mobile-navbar-dropdown-line"></div> -->
          <!-- </li> -->

          <li class="nav-item navbar-collapse dropdown mobile-dropdown-item">
            <label
              class="nav-link nav-text dropdown-toggle dropdown-toggle-split"
              id="nav-menu-more"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
              >{{ $t("navbar.more") }}&nbsp;</label
            >
            <div
              class="dropdown-menu navbar-dropdown-menu mobile-navbar-dropdown-menu"
              aria-labelledby="nav-menu-more"
            >
              <!--              <a class="dropdown-item navbar-dropdown-item" href="mailto:support@pwmat.com">{{ $t('navbar.ApplyTest') }}&nbsp;</a>
              <div class="navbar-dropdown-line"></div>-->
              <a
                class="dropdown-item navbar-dropdown-item"
                target="_blank"
                href="http://longxun2015.mikecrm.com/y72WBOU"
                >申请试用</a
              >
              <div class="navbar-dropdown-line"></div>
              <a class="dropdown-item navbar-dropdown-item" @click="toLog">{{
                $t("navbar.Log")
              }}</a>
              <div class="navbar-dropdown-line"></div>
              <a class="dropdown-item navbar-dropdown-item" @click="toTestLog"
                >Bug日志</a
              >
              <div class="navbar-dropdown-line"></div>
              <a class="dropdown-item navbar-dropdown-item" @click="toPaper">{{
                $t("navbar.Paper")
              }}</a>
              <div class="navbar-dropdown-line"></div>
              <a class="dropdown-item navbar-dropdown-item" @click="toFAQ"
                >FAQ</a
              >
              <div class="navbar-dropdown-line"></div>
              <a
                class="dropdown-item navbar-dropdown-item"
                target="_blank"
                href="http://bbs.pwmat.com/"
                >论坛</a
              >
            </div>
          </li>
          <div class="mobile-navbar-dropdown-line"></div>

          <!--          <li class="nav-item navbar-collapse dropdown mobile-dropdown-item">
            <label class="nav-link nav-text" @click="changeLanguage">{{ $t('language.name') }}&nbsp;</label>
          </li>
          <div class="mobile-navbar-dropdown-line"></div>-->
        </ul>
      </div>
    </nav>
  </div>
</template>

<script>
import { mapState } from "vuex";
import LangStorage from "./../../helpers/lang";
import { PWMAT_RESOURCE, COURSE_URL } from "./../../helpers/consts";
import $ from "jquery";

export default {
  name: "HelloWorld",
  props: {},
  data() {
    return {
      PWMAT_RESOURCE,
      COURSE_URL,
    };
  },
  computed: {
    ...mapState({
      testDocuments: (state) => state.TestDocument.testDocuments.info,
    }),
  },
  // created(){
  // this.$store.dispatch('getTestDocument').then(res => {

  //console.log(this.testDocuments)
  // })
  // },
  methods: {
    changeLanguage() {
      let lang = LangStorage.getLang("en");
      if (lang === "en") {
        this.$i18n.locale = "zh";
      } else {
        this.$i18n.locale = "en";
      }
      LangStorage.setLang(this.$i18n.locale);
    },
    toHome() {
      this.$router.push({ name: "Home" });
      $(".collapse").collapse("hide");
    },
    toCompanyIntroduce() {
      this.$router.push({ name: "CompanyIntroduce" });
      $(".collapse").collapse("hide");
    },
    toCooperate() {
      this.$router.push({ name: "Cooperate" });
      $(".collapse").collapse("hide");
    },
    toContactUs() {
      this.$router.push({ name: "ContactUs" });
      $(".collapse").collapse("hide");
    },
    toCompanyNews() {
      this.$router.push({ name: "CompanyNews", params: { page: 1 } });
      $(".collapse").collapse("hide");
    },
    toJoinUs() {
      this.$router.push({ name: "JoinUs" });
      $(".collapse").collapse("hide");
    },
    toPWmatIntroduce() {
      this.$router.push({ name: "PWmatIntroduce" });
      $(".collapse").collapse("hide");
    },
    toMLFFIntroduce() {
      this.$router.push({ name: "MLFFIntroduce" });
      $(".collapse").collapse("hide");
    },
    toLS3DFIntroduce() {
      this.$router.push({ name: "LS3DFIntroduce" });
      $(".collapse").collapse("hide");
    },
    toPWMGUIIntroduce() {
      this.$router.push({ name: "PWMGUIIntroduce" });
      $(".collapse").collapse("hide");
    },
    toQStudioIntroduce() {
      this.$router.push({ name: "QStudioIntroduce" });
      $(".collapse").collapse("hide");
    },
    toIntegration() {
      this.$router.push({ name: "Integration" });
      $(".collapse").collapse("hide");
    },
    toMSTATIONIntroduce() {
      this.$router.push({ name: "MSTATIONIntroduce" });
      $(".collapse").collapse("hide");
    },
    toMCLUSTERIntroduce() {
      this.$router.push({ name: "MCLUSTERIntroduce" });
      $(".collapse").collapse("hide");
    },
    toMcloudIntroduce() {
      this.$router.push({ name: "McloudIntroduce" });
      $(".collapse").collapse("hide");
    },
    toDMSTATIONIntroduce() {
      this.$router.push({ name: "DMSTATIONIntroduce" });
      $(".collapse").collapse("hide");
    },
    toIndustrial() {
      this.$router.push({ name: "Industrial" });
      $(".collapse").collapse("hide");
    },
    toAcademic() {
      this.$router.push({ name: "Academic" });
      $(".collapse").collapse("hide");
    },
    toPotentialDownload() {
      this.$router.push({ name: "PotentialDownload" });
      $(".collapse").collapse("hide");
    },
    toModuleDownload() {
      this.$router.push({ name: "ModuleDownload" });
      $(".collapse").collapse("hide");
    },
    toCourse() {
      window.open(this.COURSE_URL);
      $(".collapse").collapse("hide");
    },
    toTutorials() {
      this.$router.push({ name: "Tutorials" });
      $(".collapse").collapse("hide");
    },
    toLS3DFDownload() {
      this.$router.push({ name: "LS3DFDownload" });
      $(".collapse").collapse("hide");
    },
    toPWMLFFDownload() {
      this.$router.push({ name: "PWMLFFDownload" });
      $(".collapse").collapse("hide");
    },
    toVedioCourse() {
      this.$router.push({ name: "CourseVedio" });
      $(".collapse").collapse("hide");
    },
    toTrain() {
      this.$router.push({ name: "Train" });
      $(".collapse").collapse("hide");
    },
    toLongxunRoom() {
      this.$router.push({ name: "LongxunRoom" });
      $(".collapse").collapse("hide");
    },
    toQuickStartTutorial() {
      this.$router.push({ name: "QuickStartTutorial" });
      $(".collapse").collapse("hide");
    },
    toCase() {
      this.$router.push({ name: "Case" });
      $(".collapse").collapse("hide");
    },
    toReadPaper() {
      this.$router.push({ name: "ReadPaper" });
      $(".collapse").collapse("hide");
    },
    toModuleClass() {
      this.$router.push({ name: "ModuleClass" });
      $(".collapse").collapse("hide");
    },
    toCamp() {
      this.$router.push({ name: "Camp" });
      $(".collapse").collapse("hide");
    },
    toSeminar() {
      this.$router.push({ name: "Seminar" });
      $(".collapse").collapse("hide");
    },
    toFAQ() {
      this.$router.push({ name: "FAQPage" });
      $(".collapse").collapse("hide");
    },
    toForum() {
      this.$router.push({ name: "Forum" });
      $(".collapse").collapse("hide");
    },
    toPaper() {
      this.$router.push({ name: "PaperPage" });
      $(".collapse").collapse("hide");
    },
    toLog() {
      this.$router.push({ name: "LogPage" });
      $(".collapse").collapse("hide");
    },
    totrial() {
      this.$router.push({ name: "trialPage" });
      $(".collapse").collapse("hide");
    },
    toPWmatTrialDownload() {
      this.$router.push({ name: "PWmatTrialDownload" });
      $(".collapse").collapse("hide");
    },
    toPWmatFreeDownload() {
      this.$router.push({ name: "PWmatFreeDownload" });
      $(".collapse").collapse("hide");
    },
    toGPUDownload() {
      this.$router.push({ name: "GPUDownload" });
      $(".collapse").collapse("hide");
    },
    toDCUDownload() {
      this.$router.push({ name: "DCUDownload" });
      $(".collapse").collapse("hide");
    },
    toCPUDownload() {
      this.$router.push({ name: "CPUDownload" });
      $(".collapse").collapse("hide");
    },
    topwkitDownload() {
      this.$router.push({ name: "pwkitDownload" });
      $(".collapse").collapse("hide");
    },
    toHighThroughputDownload() {
      this.$router.push({ name: "HighThroughputDownload" });
      $(".collapse").collapse("hide");
    },
    toMCLUSTERDownload() {
      this.$router.push({ name: "MCLUSTERDownload" });
      $(".collapse").collapse("hide");
    },
    toWindowsDownload() {
      this.$router.push({ name: "WindowsDownload" });
      $(".collapse").collapse("hide");
    },
    toUtilityDownload() {
      this.$router.push({ name: "UtilityDownload" });
      $(".collapse").collapse("hide");
    },
    toTestDocument($id) {
      this.$router.push({ name: "TestDocument", params: { id: $id } });
    },
    toTestLog() {
      this.$router.push({ name: "TestLog" });
    },
  },
};
</script>

<style scoped>
.top-nav-container {
  width: 100%;
  padding-right: 15px !important;
  padding-left: 15px !important;
  margin-right: auto;
  margin-left: auto;
}
.navbar-elevation-all {
  background-color: rgba(255, 255, 255, 0.85);
}
.navbar-elevation {
  padding: 0;
  height: 70px;
}
.navbar-logo {
  margin-top: 10px;
  height: 25px;
  float: left;
}

.nav-item {
  float: right;
}
.nav-item:hover,
.nav-item:active {
  background: #e6e6e6;
}
.nav-text {
  cursor: pointer;
  font-size: 18px;
  font-weight: 400;
  color: #4f4c4d !important;
  padding: 15px 25px 15px 25px !important;
  margin: 0 !important;
}
.nav-text-a {
  cursor: pointer;
  font-size: 18px;
  font-weight: 400;
  color: #4f4c4d !important;
}
.nav-text-a:hover,
.nav-text-a:active,
.nav-text-a:focus {
  text-decoration: none;
}
.navbar-dropdown-item {
  padding: 10px 24px 10px 24px;
  font-weight: 400;
  color: #4f4c4d !important;
  cursor: pointer;
}
.navbar-dropdown-item:hover,
.navbar-dropdown-item:active {
  background: #e6e6e6;
  color: #4f4c4d !important;
  text-decoration: none !important;
}
.navbar-dropdown-menu {
  background: #fefefe;
  border-radius: 2px;
}
.navbar-dropdown-line {
  height: 1px;
  background: rgba(255, 255, 255, 0.2);
}
.topnav-toggler-icon {
  border-color: rgba(0, 0, 0, 1) !important;
  border: 0 solid;
}
.topnav-toggler-icon:focus {
  box-shadow: none !important;
  outline: none !important;
}
.navbar-toggler-icon-1 {
  width: 16px;
  height: 2px;
  background: rgba(73, 145, 201, 1);
}
.navbar-toggler-icon-2 {
  margin-top: 6px;
  width: 16px;
  height: 2px;
  background: rgba(73, 145, 201, 1);
}

@media screen and (max-width: 580px) {
  .top-nav-container {
    max-width: 100%;
  }
  .top-nav-container {
    max-width: 100%;
  }
  .mobile-navbar-logo {
    margin-left: 6px;
  }
  .mobile-dropdown-item {
    margin: 0;
  }
  .mobile-navbar-dropdown-line {
    height: 1px;
    background: rgba(0, 0, 0, 0.2);
    margin: 0 25px 0 25px;
  }
  .nav-item {
    height: auto;
    text-align: left !important;
  }
  .mobile-navbar-dropdown-menu {
    background: rgba(0, 0, 0, 0);
    border: 0 solid;
  }
  .navbar {
    position: relative;
    display: -ms-flexbox;
    display: -webkit-box;
    display: flex;
    -ms-flex-wrap: wrap;
    flex-wrap: wrap;
    -ms-flex-align: center;
    -webkit-box-align: center;
    align-items: center;
    -ms-flex-pack: justify;
    -webkit-box-pack: justify;
    justify-content: space-between;
    padding: 0.5rem 1rem;
  }
  .navbar-collapse {
    flex-basis: 100% !important;
  }
  .navbar-toggler {
    display: block !important;
  }
  .mobile-nav-collapse {
    margin-top: 10px !important;
    margin-left: -16px;
    margin-right: -16px;
    background: white;
    z-index: 999;
    border-top: 1px solid rgba(73, 145, 201, 1);
  }
  .collapse:not(.show) {
    display: none !important;
  }
  .nav-item {
    margin-left: 0;
    float: left;
    text-align: center;
  }
  .nav-text {
    padding: 7px 25px 5px 25px !important;
    font-size: 16px !important;
  }
  .navbar-dropdown-item {
    padding: 5px 24px 5px 24px !important;
    font-size: 16px !important;
  }
  .mobile-nav-ul {
    padding-top: 5px;
    padding-bottom: 15px;
  }
  .dropdown-menu {
    padding: 4px 0 !important;
  }
  .navbar-logo {
    height: 15px;
  }
}
@media screen and (min-width: 580px) and (max-width: 769px) {
  .top-nav-container {
    max-width: 100%;
  }
  .top-navbar-collapse {
    position: absolute;
    bottom: 0;
    right: 0;
  }
  .nav-text {
    padding-left: 8px !important;
    padding-right: 8px !important;
    font-size: 16px;
  }
  .navbar-logo {
    height: 15px;
    margin-top: 20px;
  }
}
@media screen and (min-width: 769px) and (max-width: 1000px) {
  .top-nav-container {
    max-width: 100%;
  }
  .top-navbar-collapse {
    position: absolute;
    bottom: 0;
    right: 0;
  }
  .nav-text[data-v-3de3191c] {
    padding-left: 15px !important;
    padding-right: 15px !important;
  }
}
@media screen and (min-width: 1000px) and (max-width: 1144px) {
  .top-nav-container {
    max-width: 968px;
  }
  .top-navbar-collapse {
    position: absolute;
    bottom: 0;
    right: 0;
  }
}
@media screen and (min-width: 1100px) and (max-width: 1444px) {
  .top-nav-container {
    max-width: 1068px;
  }
  .top-navbar-collapse {
    position: absolute;
    bottom: 0;
    right: 0;
  }
}
@media screen and (min-width: 1444px) {
  .top-nav-container {
    max-width: 1300px;
  }
  .top-navbar-collapse {
    position: absolute;
    bottom: 0;
    right: 0;
  }
}
/* pengge add for submenu BEGIN */
.dropdown-submenu:hover > .dropdown-menu {
  display: block;
}
.dropdown-submenu {
  position: relative;
}
.dropdown-submenu > .dropdown-menu {
  top: 0;
  left: 100%;
  margin-top: -6px;
  margin-left: -1px;
  -webkit-border-radius: 0 6px 6px 6px;
  -moz-border-radius: 0 6px 6px;
  border-radius: 0 6px 6px 6px;
}
/* pengge add for submenu END */
</style>
